import { useState, useEffect, useRef } from 'react';

function useHandleScroll() {
  const [headerShadow, setHeaderShadow] = useState(false);
  const childRef = useRef();

  useEffect(() => {
    if (childRef.current) {
      const handleScroll = () => {
        const isScrolling = childRef.current.scrollTop > 0;
        if (childRef.current !== isScrolling) {
          setHeaderShadow(isScrolling);
        }
      };

      childRef.current.addEventListener('scroll', handleScroll);
      return () => {
        childRef.current.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return {
    headerShadow,
    childRef,
  };
}

export default useHandleScroll;
